export const Constants = {
  TAG_NAME: 'pop-contributors-detractors-table-component',
  CONTRIBUTORS_NAME_COLUMN_HEADER: 'Top 10 contributors',
  DETRACTORS_NAME_COLUMN_HEADER: 'Top 10 detractors',
  PORTFOLIO_WEIGHT_COLUMN_HEADER: '% of portfolio',
  SECTOR_COLUMN_HEADER: 'Sector',
  EMPTY_CELL_VALUE: 'N/A',
  CONTRIBUTORS_NO_DATA_MESSAGE: 'Top 10 contributors data unavailable',
  DETRACTORS_NO_DATA_MESSAGE: 'Top 10 detractors data unavailable',
} as const;
